/**
 * Property name used to serialize the APP_ID of each component.
 */
export const ID_PROP_NAME = 'data-analog-id';
